import { convertEnergyPricePowertracerToPartner } from './conversions';

/**
 * Converts an internal price value (Powertracer format, e.g., dollars per Wh) into a string
 * representation (Partner format, e.g., cents per kWh) suitable for initializing a component's
 * display state (e.g., `buyPriceDisplay`, `sellPriceDisplay`, or `priceDisplay`).
 * This pure function ensures the input field receives a string value, preserving React's
 * controlled component behavior and preventing "controlled vs uncontrolled" input warnings
 * that would occur if `null` or `undefined` were passed to the `value` prop.
 * @param {object} intlCurrency - The internationalized currency configuration object,
 *   typically obtained from the `useIntlCurrency` hook. Required for currency-aware conversion.
 * @param {number|string|object|null|undefined} price - The price value in Powertracer format.
 *   Can be a numeric value, a string representation, a Big.js object, or null/undefined
 *   when no existing price is available.
 * @returns {string} The converted price as a string in Partner format, or an empty string
 *   if the input is invalid, null, undefined, or an empty string.
 * @see convertEnergyPricePowertracerToPartner - Used for the underlying currency and unit
 *   conversion from Powertracer format (dollars/Wh) to Partner format (cents/kWh).
 */
const getInitialPriceDisplayValue = (intlCurrency, price) => {
  if (price === '' || price == null) {
    return '';
  }
  const converted = convertEnergyPricePowertracerToPartner(intlCurrency, price);
  return converted != null ? String(converted) : '';
};

export default getInitialPriceDisplayValue;
